'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ApiCampaigns = function ApiCampaigns(Restangular, $http, $rootScope, ApiBaseResponseService, GenericMethods) {
    _classCallCheck(this, ApiCampaigns);

    return {
        /**
         * Get all campaigns
         * @return {Object}
         */
        getCampaigns: function getCampaigns() {
            return Restangular.one('campaigns').one('children').customGET('', {}, {
                'Content-Type': 'application/json'
            }).then(ApiBaseResponseService.onSuccess, ApiBaseResponseService.onError);
        },


        /**
         * Get campaign by Id
         * @return {Object}
         */
        getCampaign: function getCampaign(campaignId) {
            return Restangular.one('campaigns', campaignId).get().then(ApiBaseResponseService.onSuccess, ApiBaseResponseService.onError);
        },


        /**
         * Get all campaign contacts by campaignId (with minimal inforamtion)
         * @return {Object}
         */
        getCampaignContacts: function getCampaignContacts(campaignId) {
            return Restangular.one('campaigns', campaignId).one('contacts').one('all').get().then(ApiBaseResponseService.onSuccess, ApiBaseResponseService.onError);
        },


        /**
         * Get all campaign package contacts
         * @return {Object}
         */
        getCampaignPackageContacts: function getCampaignPackageContacts(campaignId, filterObj) {
            return Restangular.all('campaigns').all(campaignId).all('contacts').all('filter').post(filterObj).then(ApiBaseResponseService.onSuccess, ApiBaseResponseService.onError);
        },


        /**
         * Get all campaign team (custom) contacts
         * @return {Object}
         */
        getCampaignTeamContacts: function getCampaignTeamContacts(campaignId, filterObj) {
            return Restangular.all('campaigns').all(campaignId).all('customerContacts').all('filter').post(filterObj).then(ApiBaseResponseService.onSuccess, ApiBaseResponseService.onError);
        },


        /**
         * Get all campaign combined contacts
         * @return {Object}
         */
        getCampaignCombinedContacts: function getCampaignCombinedContacts(campaignId, filterObj) {
            return Restangular.all('campaigns').all(campaignId).all('combinedContacts').all('filter').post(filterObj).then(ApiBaseResponseService.onSuccess, ApiBaseResponseService.onError);
        },


        /**
         * Get campaign contact by Ids
         * @return {Object}
         */
        getCampaignContact: function getCampaignContact(campaignId, contactId) {
            return Restangular.one('campaigns', campaignId).one('contacts', contactId).get().then(ApiBaseResponseService.onSuccess, ApiBaseResponseService.onError);
        },
        getCampaignChildren: function getCampaignChildren(campaignId) {
            return Restangular.one('campaigns', campaignId).one('children').get().then(ApiBaseResponseService.onSuccess, ApiBaseResponseService.onError);
        },
        getAllChildCampaigns: function getAllChildCampaigns() {
            return Restangular.one('campaigns').one('children').get().then(ApiBaseResponseService.onSuccess, ApiBaseResponseService.onError);
        },
        getAllMotherCampaigns: function getAllMotherCampaigns() {
            return Restangular.one('campaigns').one('mother').get().then(ApiBaseResponseService.onSuccess, ApiBaseResponseService.onError);
        },
        getCampaignDetail: function getCampaignDetail(campaignId) {
            return Restangular.one('campaigns', campaignId).one('detailed').get().then(ApiBaseResponseService.onSuccess, ApiBaseResponseService.onError);
        },


        /**
         * Update campaign contactDetail
         * @return {Object}
         */
        updateCampaignContact: function updateCampaignContact(campaignId, contactId, contactDetail) {
            // remove unnecessary contactInfo attribute
            delete contactDetail.contactInfo;
            return Restangular.one('campaigns', campaignId).one('contacts', contactId).customPUT(contactDetail).then(ApiBaseResponseService.onSuccess, ApiBaseResponseService.onError);
        },


        /**
         * Update campaigns by contactId and campaignIds
         * @return {Object}
         */
        updateCampaignContacts: function updateCampaignContacts(contactId, customer, campaigns) {
            return Restangular.one('campaigns').one('contacts', contactId).customPUT(campaigns, '', customer).then(ApiBaseResponseService.onSuccess, ApiBaseResponseService.onError);
        },


        /**
         * Update campaigns by contactId and campaignIds
         * @return {Object}
         */
        updateCampaignInvestors: function updateCampaignInvestors(investorId, campaigns) {
            return Restangular.one('campaigns').one('investors', investorId).customPUT(campaigns).then(ApiBaseResponseService.onSuccess, ApiBaseResponseService.onError);
        },


        /**
         * Update campaigns by selectionId and campaignIds
         * @return {Object}
         */
        updateCampaignSelections: function updateCampaignSelections(selectionId, campaigns) {
            return Restangular.one('campaigns').one('selections', selectionId).customPUT(campaigns).then(ApiBaseResponseService.onSuccess, ApiBaseResponseService.onError);
        },


        /**
         * Add the selected campaigns as the children of the selected campaign. The previously existing children should be removed
         * @param {int} campaignId  Id of the mother campaign
         * @param {Array<int>} childrenIds Array of campaign ids
         */
        addChildren: function addChildren(campaignId, childrenIds) {
            var url = 'campaigns/' + campaignId.toString() + '/children';
            return Restangular.one('campaigns', campaignId).one('children').customPUT(childrenIds).then(ApiBaseResponseService.onSuccess, ApiBaseResponseService.onError);
        },


        /**
         * Delete campaign by Id
         * @return {Object}
         */
        deleteCampaign: function deleteCampaign(campaignId) {
            return Restangular.one('campaigns', campaignId).remove().then(ApiBaseResponseService.onSuccess, ApiBaseResponseService.onError);
        },


        /**
         * Delete contact from campaign by campaignId and contactId
         * @return {Object}
         */
        deleteCampaignContact: function deleteCampaignContact(campaignId, contactIdObject) {
            return Restangular.one('campaigns', campaignId).one('contacts').remove(contactIdObject).then(ApiBaseResponseService.onSuccess, ApiBaseResponseService.onError);
        },


        /**
         * Delete selection from campaign by campaignId and selectionId
         * @return {Object}
         */
        deleteCampaignSelection: function deleteCampaignSelection(campaignId, selectionIdObject) {
            return Restangular.one('campaigns', campaignId).one('selections').remove(selectionIdObject).then(ApiBaseResponseService.onSuccess, ApiBaseResponseService.onError);
        },


        /**
         * Post campaign
         * @param  {Object} campaign
         * @return {Object}
         */
        postCampaign: function postCampaign(campaign) {
            return Restangular.all('campaigns').post(campaign).then(ApiBaseResponseService.onSuccess, ApiBaseResponseService.onError);
        },


        /**
         * Put campaign
         * @param  {Object} campaign
         * @return {Object}
         */
        putCampaign: function putCampaign(campaign) {
            var campaignId = campaign.campaign.campaignId;
            return Restangular.one('campaigns', campaignId).customPUT(campaign).then(ApiBaseResponseService.onSuccess, ApiBaseResponseService.onError);
        },


        /**
         * Put campaign contacts
         * @param  {Object} campaign
         * @return {Object}
         */
        putCampaignContacts: function putCampaignContacts(campaignId, contacts) {
            return Restangular.one('campaigns', campaignId).one('contacts').customPUT(contacts).then(ApiBaseResponseService.onSuccess, ApiBaseResponseService.onError);
        },


        /**
         * Put campaign customer contacts
         * @param  {Object} campaign
         * @return {Object}
         */
        putCampaignCustomerContacts: function putCampaignCustomerContacts(campaignId, contacts) {
            return Restangular.one('campaigns', campaignId).one('customerContacts').customPUT(contacts).then(ApiBaseResponseService.onSuccess, ApiBaseResponseService.onError);
        },


        // creates Picklist number / date values
        createPicker: function createPicker(startValue, range) {
            var array = [];
            for (var i = startValue; i < startValue + range; i++) {
                array.push(i);
            }

            return array;
        },


        // Creates a list of available currencies to select from.
        retrieveCurrencyList: function retrieveCurrencyList() {
            return GenericMethods.retrieveLocalFile('data/', 'currencies.json');
        },


        /**
         * Get all campaigns with minimal info
         * @return [Object]
         */
        getCampaignsMinimal: function getCampaignsMinimal() {
            return Restangular.one('campaigns').one('children/minimal').get().then(ApiBaseResponseService.onSuccess, ApiBaseResponseService.onError);
        },
        hasParentCampaign: function hasParentCampaign(campaignId) {
            return Restangular.one('campaigns', campaignId).one('hasParents').get().then(ApiBaseResponseService.onSuccess, ApiBaseResponseService.onError);
        },
        getChartData: function getChartData(campaignId) {
            return Restangular.one('dashboard', campaignId).get().then(ApiBaseResponseService.onSuccess, ApiBaseResponseService.onError);
        },
        getActivityReport: function getActivityReport(campaignId) {
            return Restangular.one('campaigns', campaignId).one('activities').get().then(ApiBaseResponseService.onSuccess, ApiBaseResponseService.onError);
        },


        /**
         * Export activities
         */
        exportActivities: function exportActivities(campaignId) {
            return Restangular.one('campaigns', campaignId).one('activities').one('export').withHttpConfig({ responseType: 'blob' }).get().then(ApiBaseResponseService.onBlobSuccess, ApiBaseResponseService.onError);
        },
        emailActivities: function emailActivities(campaignId) {
            return Restangular.one('campaigns', campaignId).one('activities').one('export').one('email').get().then(ApiBaseResponseService.onBlobSuccess, ApiBaseResponseService.onError);
        }
    };
};

ApiCampaigns.inject = ['Restangular', 'ApiBaseResponseService'];

exports.default = ApiCampaigns;


/** WEBPACK FOOTER **
 ** ./src/app/services/apiCampaigns.js
 **/